import { Select } from "antd";
import React from "react";

import SelectNoContent from "@/Components/common/SelectNoContent";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import { SelectDownIcon } from "@/Components/Icons/SelectDownIcon";

/**
 * Generates a dropdown filter component based on the provided value, options, and other props.
 *
 * @param {object} props - The properties object containing value, options, handleChange, label, id, placeholder, and isMultiple.
 * @return {JSX.Element} The dropdown filter component.
 */
const DropDownFilter = ({
  value,
  options,
  handleChange,
  label,
  id,
  placeholder,
  isMultiple = false,
  type = "",
}) => {
  return (
    <div className={`DropDownFilter_Wrapper ${id}_Filter_Wrapper`}>
      <div className="grid gap-3 align-top">
        <label
          className="label text-[14px] !font-normal text-black"
          htmlFor={id}
        >
          {label}
        </label>
        <Select
          showSearch
          style={{ width: "100%" }}
          placeholder={placeholder}
          optionFilterProp="children"
          className="ease min-h-[40px] w-full overflow-hidden rounded-lg border border-lightGrey text-[14px] !font-medium !capitalize leading-[normal] text-black transition-all duration-200 placeholder:text-[14px] placeholder:font-medium placeholder:text-txtColor focus:border-primary"
          suffixIcon={<SelectDownIcon cls={"text-txtColor"} />}
          onChange={(value) => {
            if (type == "") {
              let maintype =
                options.find((item) => item.value === value)?.type || "";
              handleChange(value, maintype);
            } else {
              handleChange(value);
            }
          }}
          allowClear={{
            clearIcon: <RejectIcon cls="w-[20px] h-[20px] text-red" />,
          }}
          value={value}
          notFoundContent={<SelectNoContent />}
          mode={isMultiple ? "multiple" : null}
        >
          {options.map((item, index) => {
            const { value, name, type } = item;
            return (
              <Select.Option value={value} key={index}>
                {name}
                {type && <span className="ml-1 capitalize"> ({type})</span>}
              </Select.Option>
            );
          })}
        </Select>
      </div>
    </div>
  );
};

export default DropDownFilter;
